// src/componentes/ModalVerImagenes.js
import React from 'react';
import { Download, X } from 'lucide-react';
import { obtenerUrlImagenAviso } from '../servicios/api';

const ModalVerImagenes = ({ isOpen, onClose, imagenes, titulo = 'Imágenes del Aviso' }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-slate-800 rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-white">{titulo}</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <X size={24} />
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {imagenes && imagenes.length > 0 ? (
            imagenes.map((imagen, index) => (
              <div key={index} className="relative">
                <img
                  src={obtenerUrlImagenAviso(imagen)}
                  alt={`Aviso imagen ${index + 1}`}
                  className="w-full h-48 object-cover rounded-lg"
                />
                <a
                  href={obtenerUrlImagenAviso(imagen)}
                  download={imagen}
                  className="mt-2 inline-flex items-center gap-2 rounded bg-slate-700 px-3 py-2 text-sm text-white hover:bg-slate-600"
                >
                  <Download size={16} />
                  Descargar foto
                </a>
              </div>
            ))
          ) : (
            <p className="text-slate-400">IMAGENES NO HAY IMAGENES</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalVerImagenes;
